module.exports = "\r\n    <router-outlet></router-outlet>"